import type React from "react";
import { OneCardPage } from "../../../components/utils/OneCardPage.tsx";
import { useSelectedCompany } from "../../../hooks/useCompany";
import CreateAssetForm from "../assetPositions/CreateAssetForm.tsx";

const AssetCreatePage = (): React.ReactElement => {
  const company_id = useSelectedCompany()?.company_id || "NONE";

  return (
    <OneCardPage
      headerTitle={"Create Asset"}
      setPageTitle={() => "Create Asset"}
    >
      <p>Create a new unassigned asset</p>
      <CreateAssetForm companyId={company_id} />
    </OneCardPage>
  );
};

export default AssetCreatePage;
